import * as React from "react"

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
  const { height = 24, width = 24 } = props
  return (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.4998 6.66667C12.4998 4.36548 10.6343 2.5 8.33317 2.5C6.03199 2.5 4.1665 4.36548 4.1665 6.66667C4.1665 8.96783 6.03199 10.8333 8.33317 10.8333C10.6343 10.8333 12.4998 8.96783 12.4998 6.66667Z" stroke="white" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14.5832 17.5V11.6666M11.6665 14.5833H17.4998" stroke="white" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M2.5 16.6667C2.5 13.445 5.11168 10.8334 8.33333 10.8334C9.57267 10.8334 10.7218 11.2199 11.6667 11.879" stroke="white" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

  )
}

export default SvgComponent
